import React, { PropTypes, Component } from 'react'

const Feature = ({ icon, header, children }) => (
  <div className="feature">
    <img src={`/images/${icon}`} alt={icon} />
    <h3>{header}</h3>
    {children}
  </div>
)

Feature.propTypes = {
  icon: React.PropTypes.string.isRequired,
  header: React.PropTypes.string.isRequired,
  children: React.PropTypes.any.isRequired,
}

export default Feature



// WEBPACK FOOTER //
// ./src/browser/components/Feature.js